<script setup lang="ts">
  import { isHolidaySeason, useScreenSize } from '@/shared/lib'
  import { useAppConfig } from '@/shared/lib/tenant'

  import { useCart } from '@/entities/shop'

  import BurgerMenu from './BurgerMenu.vue'
  import UserMenu from './UserMenu.vue'

  const props = defineProps<{
    modelValue: boolean
  }>()

  const emits = defineEmits<{
    (e: 'toggleBurger', value: boolean): void
  }>()

  const { fromDesktopMedium } = storeToRefs(useScreenSize())
  const showBurger = computed(() => !fromDesktopMedium.value)

  const burgerIsActive = computed({
    get() {
      return props.modelValue
    },
    set(value) {
      emits('toggleBurger', value)
    },
  })
  const router = useRouter()

  const handleClickOnLogo = () => {
    router.push('/')
  }

  const { logoUrl } = useAppConfig()
  const { getTotalQuantity } = storeToRefs(useCart())
</script>

<template>
  <div class="z-4 flex h-16 w-full items-center justify-center bg-(--color-primary)">
    <div class="desktop-1660:max-w-7xl desktop-1920:max-w-360 flex w-full items-center px-6">
      <BurgerMenu
        v-if="showBurger"
        v-model="burgerIsActive"
        class="mr-6.25"
      />

      <button
        class="relative mr-6 flex cursor-pointer items-center gap-3"
        type="button"
        aria-label="Go to homepage"
        @click="handleClickOnLogo"
      >
        <img
          v-if="isHolidaySeason()"
          src="@/assets/img/logoChristmasHat.png"
          class="absolute -top-1.75 -left-1 w-4"
          alt=""
        />
        <img
          v-if="logoUrl"
          :src="logoUrl"
          class="w-52"
          alt=""
        />
      </button>

      <div class="ml-auto flex items-center justify-center">
        <RouterLink
          v-slot="{ navigate }"
          :to="{ name: '/shop/cart/' }"
          custom
        >
          <NButton
            quaternary
            strong
            :aria-label="$t('shop_aria_cart', { count: getTotalQuantity })"
            class="[&_.n-button\_\_content]:text-invert"
            @click="navigate"
          >
            <i
              class="fa-regular fa-cart-shopping relative mr-1.5"
              aria-hidden="true"
            >
              <i
                v-if="getTotalQuantity > 0"
                class="bg-error absolute -top-0.75 -right-0.5 size-1.5 rounded-full"
              />
            </i>
            {{ getTotalQuantity }}
          </NButton>
        </RouterLink>

        <UserMenu class="ml-auto pl-4" />
      </div>
    </div>
  </div>
</template>
